import { API_URL } from "../_config/config.const";
import { handleResponse } from "../_helpers/handleResponse.helper";
import { getHeader } from "../_helpers/header.helper";

const API_NAME = "xero";

export const xeroService = {
    getLoginUrl,
    getStatus
};

function getLoginUrl() {
    const requestOptions = { method: 'GET', headers: getHeader() };
    return fetch(`${API_URL}/${API_NAME}/GetLoginUrl/`, requestOptions).then(handleResponse);
}

async function getStatus() {
    const requestOptions = { method: 'GET', headers: getHeader() };
    return await fetch(`${API_URL}/xero/GetStatus`, requestOptions).then(handleResponse);
}
